import React from "react";
import { Navigate } from "react-router-dom";
import { canAccessAdminPath, getAllowedAdminPaths } from "../../utils/hasAdminPermission";

const ProtectedAdminRoute = ({ path, children }) => {
  if (!canAccessAdminPath(path)) {
    const allowedPaths = getAllowedAdminPaths();
    const fallback = allowedPaths?.length ? `/${allowedPaths[0]}` : "/unauthorized";
    // return <Navigate to={fallback} replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
